import { BaseCommand } from './BaseCommand';
import type { PromptCommandCategory } from './PromptCommandCategory';
import type { AnyCommand, CommandActionContext, CommandShortcut } from '~/lib/stores/command/types';

export class GroupCommand extends BaseCommand {
  commands: AnyCommand[];
  category?: PromptCommandCategory;

  constructor(details: {
    id: string;
    name: string;
    icon?: string;
    commands: AnyCommand[];
    category?: PromptCommandCategory;
  }) {
    super(details);
    this.commands = details.commands;
    this.category = details.category;
  }

  action({ commandStore, setInput }: CommandActionContext) {
    commandStore.router.push(this);
    setInput('/');
  }

  shortcuts: CommandShortcut[] = [
    {
      label: 'Open',
      keys: ['Enter'],
      action: (context) => this.action(context),
    } satisfies CommandShortcut,
    {
      id: 'favorite',
      label: 'Toggle Favorite',
      keys: ['Meta', 'Shift', 'L'],
      action: ({ commandStore }) => {
        commandStore.toggleFavorite(this.id);
      },
    } satisfies CommandShortcut,
  ];

  withCommands(commands: AnyCommand[]) {
    return new GroupCommand({
      ...this,
      commands: [...this.commands, ...commands],
    });
  }
}
